var React = require('react');

function SChevronDownMedium18N (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M13.99,7.01a.9999.9999,0,0,0-1.70734-.70673L9,9.58594,5.71734,6.30327A.9999.9999,0,1,0,4.30082,7.71489l3.99184,3.98184a.99966.99966,0,0,0,1.41372.001l3.99035-3.98035A.99668.99668,0,0,0,13.99,7.01Z","fill":"var(--iconFill, #464646)"}));
}

SChevronDownMedium18N.defaultProps = {"width":"18","height":"18","viewBox":"0 0 18 18"};

module.exports = SChevronDownMedium18N;

SChevronDownMedium18N.default = SChevronDownMedium18N;
